import React from 'react';

const money = (v) => Number(v || 0).toFixed(2);

export default function PackageCircleCard({ pkg, onOpen, onDelete }) {
  const price = Number(pkg?.price ?? pkg?.currentPrice ?? 0);
  const mins = Number(pkg?.totalDuration ?? pkg?.duration ?? 0);

  return (
    <div style={{ display: 'grid', justifyItems: 'center', gap: 8 }}>
      <button className="pkg2-circleBtn" type="button" onClick={onOpen} aria-label={`Edit ${pkg?.name || 'package'}`}>
        <div className="pkg2-circleThumb" aria-hidden>
          {pkg?.imageUrl ? <img src={pkg.imageUrl} alt="" /> : <div className="pkg2-circleFallback">📦</div>}
        </div>
        <div className="pkg2-circleLabel" title={pkg?.name || ''}>
          {pkg?.name || 'Untitled'}
        </div>
        <div className="pkg2-circleMeta">
          ${money(price)} • {mins}m{pkg?.isDiscountApplied && Number(pkg?.discount || 0) > 0 ? ` • ${pkg.discount}% off` : ''}
        </div>
      </button>
      {typeof onDelete === 'function' ? (
        <button className="pkg2-dangerLink" type="button" onClick={onDelete}>
          Delete
        </button>
      ) : null}
    </div>
  );
}

